// test1689
(1689 && 0);
